import './view4.scss'

import MobileImageView5 from '../../../img/landing/mobile-view-5.svg'
import DesktopImageView5 from '../../../img/landing/desktop-view-5.svg'
import backgroundView4 from "../../../img/landing/mobile-background-view-4.png";
import woman from "../../../img/landing/woman-avatar.png";
import man from "../../../img/landing/man-avatar.svg";
import womanDark from "../../../img/landing/woman-avatar-dark.png";
import manDark from "../../../img/landing/man-avatar-dark.png";
import plusIcon from "../../../img/landing/add.svg";
import minusIcon from "../../../img/landing/minus.svg";
import refreshIcon from "../../../img/landing/refresh-2.svg";
import goldIcon from "../../../img/landing/gold.svg";
import Icon1 from "../../../img/imoji/imoji1.png";
import Icon2 from "../../../img/imoji/imoji2.png";
import Icon3 from "../../../img/imoji/imoji3.png";
import Icon4 from "../../../img/imoji/imoji4.png";
import Icon5 from "../../../img/imoji/imoji5.png";

import React, {useEffect, useState} from "react";
import {Button} from "rsuite";
import {toast, ToastContainer} from "react-toastify";

const View4 = () => {

    const preFormData = {
        gender: null,
        age: null,
        height: '165',
        weight: '75',

    };
    const preAnswers = {
        extra: {
            'icon': Icon1,
            'text': 'شما دچار چاقی شدید هستید',
        },
        gain:
            {
                'icon': Icon2,
                'text': 'شما اضافه وزن دارید',
            },
        normal:
            {
                'icon': Icon3,
                'text': 'وزن شما نرمال است',
            },
        under:
            {
                'icon': Icon4,
                'text': 'شما کمبود وزن دارید',
            },
        border:
            {
                'icon': Icon5,
                'text': 'شما در مرز چاقی قرار دارید',
            },

    }

    const checkWeightStatus = (x) => {
        if (x >=13) {
            return 6;
        }

        else if (x >= 6 && x <= 12) {
            return  3;
        }
        else if (x >= 3 || x <= 5) {
            return 1;
        }
        return '';
    }

    const checkWeight = (bmi) => {
        if ( bmi < 18.5) {
            return setAnswer(preAnswers.under);
        }
        if (bmi >= 18.5  && bmi <= 24.9) {
            return setAnswer(preAnswers.normal);
        }
        if (bmi>= 25 &&  bmi <= 29.9) {
            return setAnswer(preAnswers.border);
        }
        if (bmi>= 30 &&  bmi <= 34.9) {
            return setAnswer(preAnswers.gain);
        }
        if (bmi>= 35) {
            return setAnswer(preAnswers.extra);
        }
        return '';
    }
    const [formData, setFormData] = useState(preFormData);
    const [answer, setAnswer] = useState(null);
    const [weightGain, setWeightGain] = useState(0);
    const [weightLoos, setWeightLoos] = useState(0);
    const [healthyWeightRange, setHealthyWeightRange] = useState('');
    const [month, setMonth] = useState('');
    const [activeIndex, setActiveIndex] = useState(null);

    const handleChange = (name, value) => {
        //if (validation(name, value)) {

            const newValue = value.replace(/\D/g, '');
            value = (newValue.slice(0, 3));

            formData[name] = value;
            setFormData({...formData});

            if(name=='gender'){
                setActiveIndex(value)
            }
        //}
    }
    const handleClick = (name, type) => {

        let value = parseInt(formData[name]);
            value = type == 'plus' ? value + 1 : value;
            value = type == 'minus' && value > 1 ? value - 1 : value;

            handleChange(name, value.toString());
    }

    const handleCalculation = () => {
        if(validation()) {
            const weight = formData.weight;
            const height = formData.height / 100;

            const bmi = weight / (height * height);
            const healthyWeightMin = Math.ceil(18.5 * height * height);
            const healthyWeightMax = Math.floor(24.9 * height * height);

            setHealthyWeightRange(`${healthyWeightMin} تا ${healthyWeightMax}`);
            const gain = weight - healthyWeightMax;
            const under = healthyWeightMin - weight;//???

            setWeightGain(gain > 0 ? gain : 0);
            setWeightLoos(under>0 ?under:0);
            //todo its needed to change checkWeightStatus base loss too
            setMonth(checkWeightStatus(gain>0?gain:under));
            checkWeight(bmi);
            changeOldToNewVersion(formData)
        }
    }


    const handleRegimeClick = () => {

        window.location.href = '/new-form'
    }

    const handleRefresh = () => {
        initialize();
    }

    const initialize = () => {
        setFormData({...preFormData});
        setAnswer(false);
        setActiveIndex(null);
    }

    const numberValidate = (value, min, max) => {
        //const number = parseInt(value);
        return !(value < min || value > max)

    }


    const validation = () => {
        let validate=true;
        const message= {
            weight:['وزن نمیتواند خالی باشد' ,' وزن باید بین 40 تا 150 باشد'],
            height:['قد نمیتواند خالی باشد' ,' قد باید بین 120 تا 240 باشد'],
            age:['سن نمیتواند خالی باشد' ,' سن باید بیشتر از 20  و کمتر از 110 باشد'],
            gender:['جنسیت خود را انتخاب کنید'],
        }
       const validData={
           weight:{min:40,max:150},
           height:{min:120,max:240},
           age:{min:20,max:110},
        }

        for (const [name, value] of Object.entries(formData)) {

            if( !parseInt(value)){
                validate=false

                toast.error(message[name][0], {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
            else if(validData[name] && validData[name]?.min && !numberValidate(value,validData[name].min,validData[name].max))
            {   validate=false

                toast.error(message[name][1], {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                }
        }
        return validate;


    }

    useEffect(() => {

    }, [formData]);


    function changeOldToNewVersion(regimeFormOld) {

        const queryParams = [
            {
                name: 'weight',
                value: regimeFormOld.weight
            },
            {
                name: 'height',
                value: regimeFormOld.height
            },
            {
                name: 'gender',
                value: regimeFormOld.gender
            },
            {
                name: 'age',
                value: regimeFormOld.age
            },
        ];
        localStorage.setItem('regime_form_old', JSON.stringify(queryParams));
    }

    return (<>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <div id={'analysis'} className={'view4'} >
                <div  className={` container-view4 `}>

                    <div className={` content-view4 `}>
                        <div className={'card-content'}>
                            <div className={` text-medium text-bolder mb-4`}>آنالیز وضعیت جسمی</div>
                            <div className={'bottom-border-green'}/>
                            <div className={` text-content `}>اطلاعاتت رو وارد کن و ببین تا رسیدن به تناسب اندام چقدر فاصله
                                داری!
                            </div>
                        </div>


                        <div>
                            <div className={`form-content${answer ? '-d-none' : ''}`}>
                                <div className={'avatar-container'}>


                                    <div className={`gender ${activeIndex === '2' ? 'selected' : ''}`} onClick={() => handleChange('gender', '2')}>
                                        <div className='image-container'>
                                            <img className={`avatar${activeIndex === '2' ? '-active' : ''}`}
                                                 src={`${woman}`} width={'147'} height={'147'}/>
                                        </div>
                                        <div className={'text'}>
                                            خانم
                                        </div>
                                    </div>
                                    <div className={`gender ${activeIndex === '1' ? 'selected' : ''}`} onClick={() => handleChange('gender', '1')}>
                                        <div className='image-container'>
                                            <img className={`avatar${activeIndex === '1' ? '-active' : ''}`}
                                                 src={`${man}`} width='147'/>
                                        </div>
                                        <div className={'text'}>
                                        آقا
                                        </div>
                                    </div>


                                </div>

                                <div className={'age-container'}>
                                    <div className={`text`}>
                            <span>
                                سن
                            </span>
                                    </div>
                                    <div className={`input-container`}>
                                        <input name='age' className={`input`} type='text' placeholder={`سن خود را وارد کنید`}
                                               onChange={(event) => handleChange('age', event.target.value)}
                                               value={formData?.age?? '' }/>
                                    </div>

                                </div>

                                <div className={'bmi-container'}>
                                    <div className={'input-container'}>
                                        <div className={`text`}>
                            <span>
                                قد
                            </span>
                                            <span className={`input-span`}>
                                (سانتی متر)
                            </span>
                                        </div>
                                        <div className={`input-contents`}>

                                            <button
                                                onClick={() => handleClick('height', 'plus')}
                                                className={'input-button '}
                                            ><img src={plusIcon}/></button>
                                            <input name="height" className={`input`} type='text' placeholder=''
                                                   value={formData.height}
                                                   onChange={(event) => handleChange(event.target.name, event.target.value)}
                                                   onClick={()=> 'autoFocus'}
                                            />
                                            <button
                                                onClick={() => handleClick('height', 'minus')}
                                                className={'input-button '}
                                            ><img src={minusIcon}/></button>
                                        </div>

                                    </div>
                                    <div className={'input-container'}>
                                        <div className={`text`}>
                            <span>
                                وزن
                            </span>
                                            <span className={`input-span`}>
                                (کیلوگرم)
                            </span>
                                        </div>
                                        <div className={`input-contents`}>

                                            <button
                                                onClick={() => handleClick('weight', 'plus')}
                                                className={'input-button '}
                                            ><img src={plusIcon}/></button>
                                            <input name="weight" className={`input`} type='text' placeholder=''
                                                   value={formData.weight}
                                                   onChange={(event) => handleChange(event.target.name, event.target.value)}
                                                   onClick={()=> 'autoFocus'}
                                            />
                                            <button
                                                onClick={() => handleClick('weight', 'minus')}
                                                className={'input-button '}
                                            ><img src={minusIcon}/></button>
                                        </div>

                                    </div>
                                </div>

                                <div className={`button-container`}>
                                    <Button appearance={'primary'}
                                            loading={false}
                                            onClick={() => handleCalculation(true)}
                                            className={`calculation-button`}
                                            block>
                                        محاسبه کن
                                    </Button>
                                    <div className={'refresh'}>
                                        <img src={refreshIcon} onClick={() => handleRefresh()}/>
                                        <span onClick={() => handleRefresh()}> دوباره امتحان کن</span>

                                    </div>
                                </div>
                            </div>

                            <div className={`answers-content${answer ? '' : '-d-none'}`}>
                                <div className='title'>
                                    تحلیل وضعیت فعلی شما
                                </div>


                                <div className={'answer-container'}>
                                    {answer && (<div className={`warning-body`}>

                                        <img src={answer.icon} className={'icon'} alt={'imoji'}/>
                                        <span className={'text'}>{answer.text}</span>

                                    </div>)
                                    }
                                    <div className={'input-contents'}>
                                        <div className={'input-container'}>
                                            <div >{weightLoos ?'میزان کمبود وزن:' : 'میزان اضافه وزن:'}</div>
                                            <div > { weightGain==weightLoos ?'ندارید':
                                                (weightLoos > 0 ? weightLoos : weightGain) }
                                                <span className={'unit'}>{weightGain==weightLoos ?  '':'کیلوگرم'}</span>
                                            </div>
                                        </div>

                                        <div className={'input-container'}>
                                            <div>محدوده وزن سالم:</div>
                                            <div> {healthyWeightRange}
                                                <span className={'unit'}>کیلوگرم</span>
                                            </div>

                                        </div>
                                    </div>

                                    <div className={'contents'}>
                                        <div className={'title'}>
                                            <img src={goldIcon}/>
                                            اراده از تو، برنامه از ما
                                        </div>
                                        <div className=''>
                                            {month && (
                                                <>
                                                    <span>همین الان از چنگال رژیم بگیر تا</span>
                                                    <span className={'span-bold'}>{month}</span>
                                                    <span>ماه دیگه به اندام متناسب رسیده باشی</span>
                                                </>
                                                )
                                            }

                                        </div>
                                    </div>

                                </div>
                                <div className={'button-container'}>
                                    <Button appearance={'primary'}
                                            loading={false}
                                            onClick={() => handleRegimeClick()}
                                            className={`calculation-button`}
                                            block>
                                        دریافت رژیم
                                    </Button>
                                    <div className={'refresh'}>
                                        <img src={refreshIcon} onClick={() => handleRefresh('reassessment')}/>
                                        <span className={'text'} onClick={() => handleRefresh('reassessment')}> دوباره امتحان کن</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
export default View4;